<script>
  let { assetsPath = '/', onAiMounted = () => {} } = $props();
  import { onMount } from 'svelte';
  onMount(() => {
    onAiMounted();
  });
</script>

<div id="g-p4_natanz-box">
  <!-- Artboard: xs -->
  <div
    id="g-p4_natanz-xs"
    class="g-artboard"
    style="display: none;aspect-ratio: 0.45833333333333;"
  >
    <div
      id="g-p4_natanz-xs-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/p4_natanz-xs.jpg);"
    ></div>
    <div
      id="g-ai0-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:7.4303%;margin-top:-7.5px;left:49.0556%;width:58px;"
    >
      <p class="g-pstyle0">Natanz</p>
    </div>
    <div
      id="g-ai0-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:11.0414%;margin-top:-7.5px;left:53.8106%;margin-left:-28px;width:56px;"
    >
      <p class="g-pstyle1">IRAN</p>
    </div>
    <div
      id="g-ai0-3"
      class="g-text g-aiAbs"
      style="top:19.0278%;left:3.0306%;width:74.5455%;"
    >
      <p>
        Natanz is located under a taller mountain than Fordow. If its tunnels
        were excavated horizontally from entrances at the base, the centrifuge
        halls could lie much deeper: <span class="g-cstyle0"
          >between 78 and 145 metres.</span
        >
      </p>
    </div>
    <div
      id="g-ai0-4"
      class="g-text g-aiAbs g-aiPointText"
      style="top:41.7531%;margin-top:-15.6px;right:52.5308%;width:113px;"
    >
      <p class="g-pstyle2">Natanz</p>
      <p class="g-pstyle2">nuclear facility</p>
    </div>
    <div
      id="g-ai0-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:48.0031%;margin-top:-15.6px;right:67.6468%;width:106px;"
    >
      <p class="g-pstyle2">Underground</p>
      <p class="g-pstyle2">complex</p>
    </div>
    <div
      id="g-ai0-6"
      class="g-text g-aiAbs g-aiPointText"
      style="top:57.6444%;margin-top:-8px;left:81.3208%;margin-left:-31.5px;width:63px;"
    >
      <p class="g-pstyle3">1000 m</p>
    </div>
    <div
      id="g-ai0-7"
      class="g-text g-aiAbs g-aiPointText"
      style="top:69.9418%;margin-top:-16.6px;left:4.1928%;width:104px;"
    >
      <p class="g-pstyle4">Mountain</p>
      <p class="g-pstyle4">peak 1,608 m.</p>
    </div>
    <div
      id="g-ai0-8"
      class="g-shadow g-aiAbs g-aiPointText"
      style="top:71.3307%;margin-top:-16.6px;left:81.0003%;margin-left:-74.5px;width:149px;"
    >
      <p class="g-pstyle5">Natanz underground</p>
      <p class="g-pstyle5">nuclear facility</p>
    </div>
    <div
      id="g-ai0-9"
      class="g-shadow g-aiAbs g-aiPointText"
      style="top:79.9418%;margin-top:-8.6px;left:49.965%;width:128px;"
    >
      <p class="g-pstyle6">Tunnels entrances</p>
    </div>
    <div
      id="g-ai0-10"
      class="g-text g-aiAbs g-aiPointText"
      style="top:95.4974%;margin-top:-8.6px;left:1.6647%;width:95px;"
    >
      <p class="g-pstyle7">78 to 145 m.</p>
    </div>
  </div>

  <!-- Artboard: sm -->
  <div
    id="g-p4_natanz-sm"
    class="g-artboard"
    style="display: none;aspect-ratio: 0.76119402985075;"
  >
    <div
      id="g-p4_natanz-sm-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/p4_natanz-sm.jpg);"
    ></div>
    <div
      id="g-ai1-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:7.9848%;margin-top:-7.5px;left:49.389%;width:58px;"
    >
      <p class="g-pstyle0">Natanz</p>
    </div>
    <div
      id="g-ai1-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:11.8654%;margin-top:-7.5px;left:52.4657%;margin-left:-28px;width:56px;"
    >
      <p class="g-pstyle1">IRAN</p>
    </div>
    <div
      id="g-ai1-3"
      class="g-text g-aiAbs"
      style="top:20.7463%;left:1.961%;width:28.8235%;"
    >
      <p>
        Natanz is located under a taller mountain than Fordow. If its tunnels
        were excavated horizontally from entrances at the base, the centrifuge
        halls could lie much deeper: <span class="g-cstyle0"
          >between 78 and 145 metres.</span
        >
      </p>
    </div>
    <div
      id="g-ai1-4"
      class="g-text g-aiAbs g-aiPointText"
      style="top:27.8541%;margin-top:-15.6px;right:30.8022%;width:113px;"
    >
      <p class="g-pstyle2">Natanz</p>
      <p class="g-pstyle2">nuclear facility</p>
    </div>
    <div
      id="g-ai1-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:34.5705%;margin-top:-15.6px;right:40.5831%;width:106px;"
    >
      <p class="g-pstyle2">Underground</p>
      <p class="g-pstyle2">complex</p>
    </div>
    <div
      id="g-ai1-6"
      class="g-text g-aiAbs g-aiPointText"
      style="top:45.0805%;margin-top:-8px;left:91.1017%;margin-left:-31.5px;width:63px;"
    >
      <p class="g-pstyle3">1000 m</p>
    </div>
    <div
      id="g-ai1-7"
      class="g-shadow g-aiAbs g-aiPointText"
      style="top:54.4275%;margin-top:-16.7px;left:78.2752%;margin-left:-83.5px;width:167px;"
    >
      <p class="g-pstyle4">Natanz underground</p>
      <p class="g-pstyle4">nuclear facility</p>
    </div>
    <div
      id="g-ai1-8"
      class="g-shadow g-aiAbs g-aiPointText"
      style="top:75.8392%;margin-top:-9.1px;left:73.4985%;width:136px;"
    >
      <p class="g-pstyle5">Tunnels entrances</p>
    </div>
    <div
      id="g-ai1-9"
      class="g-text g-aiAbs g-aiPointText"
      style="top:81.6539%;margin-top:-20.1px;left:4.302%;width:78px;"
    >
      <p class="g-pstyle6">Mountain</p>
      <p class="g-pstyle6">peak</p>
      <p class="g-pstyle6">1,608 m.</p>
    </div>
    <div
      id="g-ai1-10"
      class="g-text g-aiAbs g-aiPointText"
      style="top:94.9437%;margin-top:-9.1px;left:1.8662%;width:101px;"
    >
      <p class="g-pstyle7">78 to 145 m.</p>
    </div>
  </div>

  <!-- Artboard: md -->
  <div
    id="g-p4_natanz-md"
    class="g-artboard"
    style="display: none;aspect-ratio: 0.92957746478873;"
  >
    <div
      id="g-p4_natanz-md-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/p4_natanz-md.jpg);"
    ></div>
    <div
      id="g-ai2-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:6.2673%;margin-top:-7.5px;left:49.5278%;width:58px;"
    >
      <p class="g-pstyle0">Natanz</p>
    </div>
    <div
      id="g-ai2-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:9.9293%;margin-top:-7.5px;left:51.9053%;margin-left:-28px;width:56px;"
    >
      <p class="g-pstyle1">IRAN</p>
    </div>
    <div
      id="g-ai2-3"
      class="g-text g-aiAbs"
      style="top:10.8451%;left:1.5153%;width:37.2727%;"
    >
      <p>
        Natanz is located under a taller mountain than Fordow. If its tunnels
        were excavated horizontally from entrances at the base, the centrifuge
        halls could lie much deeper: <span class="g-cstyle0"
          >between 78 and 145 metres.</span
        >
      </p>
    </div>
    <div
      id="g-ai2-4"
      class="g-text g-aiAbs g-aiPointText"
      style="top:23.6088%;margin-top:-15.6px;right:24.9691%;width:113px;"
    >
      <p class="g-pstyle2">Natanz</p>
      <p class="g-pstyle2">nuclear facility</p>
    </div>
    <div
      id="g-ai2-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:29.9468%;margin-top:-15.6px;right:32.5271%;width:106px;"
    >
      <p class="g-pstyle2">Underground</p>
      <p class="g-pstyle2">complex</p>
    </div>
    <div
      id="g-ai2-6"
      class="g-text g-aiAbs g-aiPointText"
      style="top:39.8647%;margin-top:-8px;left:91.9567%;margin-left:-31.5px;width:63px;"
    >
      <p class="g-pstyle3">1000 m</p>
    </div>
    <div
      id="g-ai2-7"
      class="g-shadow g-aiAbs g-aiPointText"
      style="top:52.7754%;margin-top:-19.7px;left:74.6773%;margin-left:-88px;width:176px;"
    >
      <p class="g-pstyle4">Natanz underground</p>
      <p class="g-pstyle4">nuclear facility</p>
    </div>
    <div
      id="g-ai2-8"
      class="g-shadow g-aiAbs g-aiPointText"
      style="top:73.3975%;margin-top:-9.1px;left:77.396%;width:136px;"
    >
      <p class="g-pstyle5">Tunnels entrances</p>
    </div>
    <div
      id="g-ai2-9"
      class="g-text g-aiAbs g-aiPointText"
      style="top:76.2849%;margin-top:-17.6px;left:4.4971%;width:110px;"
    >
      <p class="g-pstyle6">Mountain</p>
      <p class="g-pstyle6">peak 1,608 m.</p>
    </div>
    <div
      id="g-ai2-10"
      class="g-text g-aiAbs g-aiPointText"
      style="top:91.2849%;margin-top:-9.1px;left:1.7041%;width:101px;"
    >
      <p class="g-pstyle7">78 to 145 m.</p>
    </div>
  </div>

  <!-- Artboard: lg -->
  <div
    id="g-p4_natanz-lg"
    class="g-artboard"
    style="display: none;aspect-ratio: 1.63157894736842;"
  >
    <div
      id="g-p4_natanz-lg-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/p4_natanz-lg.jpg);"
    ></div>
    <div
      id="g-ai4-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:7.6312%;margin-top:-7.5px;left:49.6649%;width:58px;"
    >
      <p class="g-pstyle0">Natanz</p>
    </div>
    <div
      id="g-ai4-2"
      class="g-text g-aiAbs"
      style="top:8.4211%;left:14.4208%;width:26.4516%;"
    >
      <p>
        Natanz is located under a taller mountain than Fordow. If its tunnels
        were excavated horizontally from entrances at the base, the centrifuge
        halls could lie much deeper: <span class="g-cstyle0"
          >between 78 and 145 metres.</span
        >
      </p>
    </div>
    <div
      id="g-ai4-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:12.2145%;margin-top:-15.6px;right:16.1574%;width:113px;"
    >
      <p class="g-pstyle1">Natanz</p>
      <p class="g-pstyle1">nuclear facility</p>
    </div>
    <div
      id="g-ai4-4"
      class="g-text g-aiAbs g-aiPointText"
      style="top:12.3681%;margin-top:-7.5px;left:51.3521%;margin-left:-28px;width:56px;"
    >
      <p class="g-pstyle2">IRAN</p>
    </div>
    <div
      id="g-ai4-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:20.1092%;margin-top:-15.6px;right:21.5212%;width:106px;"
    >
      <p class="g-pstyle1">Underground</p>
      <p class="g-pstyle1">complex</p>
    </div>
    <div
      id="g-ai4-6"
      class="g-shadow g-aiAbs g-aiPointText"
      style="top:35.0506%;margin-top:-18.8px;left:50.0209%;margin-left:-97px;width:194px;"
    >
      <p class="g-pstyle3">Natanz underground</p>
      <p class="g-pstyle3">nuclear facility</p>
    </div>
    <div
      id="g-ai4-7"
      class="g-text g-aiAbs g-aiPointText"
      style="top:37.0318%;margin-top:-8.1px;left:96.8254%;margin-left:-33.5px;width:67px;"
    >
      <p class="g-pstyle4">1000 m</p>
    </div>
    <div
      id="g-ai4-8"
      class="g-text g-aiAbs g-aiPointText"
      style="top:56.2496%;margin-top:-21.6px;left:0.5138%;width:82px;"
    >
      <p class="g-pstyle5">Mountain</p>
      <p class="g-pstyle5">peak</p>
      <p class="g-pstyle5">1,608 m.</p>
    </div>
    <div
      id="g-ai4-9"
      class="g-shadow g-aiAbs g-aiPointText"
      style="top:54.5829%;margin-top:-11.1px;left:71.0159%;width:136px;"
    >
      <p class="g-pstyle6">Tunnels entrances</p>
    </div>
    <div
      id="g-ai4-10"
      class="g-text g-aiAbs g-aiPointText"
      style="top:87.8358%;margin-top:-9.7px;left:3.4443%;width:106px;"
    >
      <p class="g-pstyle7">78 to 145 m.</p>
    </div>
  </div>
</div>

<!-- End ai2html - 2025-06-20 15:33 -->

<!-- Generated by ai2html v0.101.0 - 2025-06-20 15:33 -->
<!-- ai file: p4_natanz.ai -->
<style lang="scss">
  #g-p4_natanz-box,
  #g-p4_natanz-box .g-artboard {
    margin: 0 auto;
  }
  #g-p4_natanz-box p {
    margin: 0;
  }
  #g-p4_natanz-box .g-aiAbs {
    position: absolute;
  }
  #g-p4_natanz-box .g-aiImg {
    position: absolute;
    top: 0;
    display: block;
    width: 100% !important;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  #g-p4_natanz-box .g-aiPointText p {
    white-space: nowrap;
  }
  #g-p4_natanz-box {
    container-type: inline-size;
    @container (min-width:0px) and (max-width: 509px) {
      #g-p4_natanz-xs {
        display: block !important;
      }
    }
    @container (min-width:510px) and (max-width: 659px) {
      #g-p4_natanz-sm {
        display: block !important;
      }
    }
    @container (min-width:660px) and (max-width: 929px) {
      #g-p4_natanz-md {
        display: block !important;
      }
    }
    @container (min-width:930px) {
      #g-p4_natanz-lg {
        display: block !important;
      }
    }
  }
  #g-p4_natanz-xs {
    position: relative;
    overflow: hidden;
  }
  #g-p4_natanz-xs p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 400;
    line-height: 17px;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 15px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-p4_natanz-xs .g-pstyle0 {
    line-height: 14px;
    height: 14px;
    font-size: 12px;
  }
  #g-p4_natanz-xs .g-pstyle1 {
    line-height: 14px;
    height: 14px;
    letter-spacing: 0.2em;
    font-size: 12px;
    text-align: center;
    color: rgb(122, 122, 122);
  }
  #g-p4_natanz-xs .g-pstyle2 {
    line-height: 15px;
    height: 15px;
    text-align: right;
    color: rgb(255, 255, 255);
  }
  #g-p4_natanz-xs .g-pstyle3 {
    line-height: 15px;
    height: 15px;
    font-size: 13px;
    text-align: center;
    color: rgb(186, 186, 186);
  }
  #g-p4_natanz-xs .g-pstyle4 {
    line-height: 16px;
    height: 16px;
    font-size: 14px;
    color: rgb(116, 116, 116);
  }
  #g-p4_natanz-xs .g-pstyle5 {
    font-weight: 700;
    line-height: 16px;
    height: 16px;
    font-size: 14px;
    text-align: center;
    color: rgb(255, 255, 255);
  }
  #g-p4_natanz-xs .g-pstyle6 {
    line-height: 16px;
    height: 16px;
    font-size: 14px;
    color: rgb(255, 255, 255);
  }
  #g-p4_natanz-xs .g-pstyle7 {
    font-weight: 700;
    line-height: 16px;
    height: 16px;
    font-size: 14px;
    color: rgb(165, 15, 21);
  }
  #g-p4_natanz-xs .g-cstyle0 {
    font-weight: 700;
    color: rgb(165, 15, 21);
  }
  #g-p4_natanz-sm {
    position: relative;
    overflow: hidden;
  }
  #g-p4_natanz-sm p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 400;
    line-height: 17px;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 15px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-p4_natanz-sm .g-pstyle0 {
    line-height: 14px;
    height: 14px;
    font-size: 12px;
  }
  #g-p4_natanz-sm .g-pstyle1 {
    line-height: 14px;
    height: 14px;
    letter-spacing: 0.2em;
    font-size: 12px;
    text-align: center;
    color: rgb(122, 122, 122);
  }
  #g-p4_natanz-sm .g-pstyle2 {
    line-height: 15px;
    height: 15px;
    text-align: right;
    color: rgb(255, 255, 255);
  }
  #g-p4_natanz-sm .g-pstyle3 {
    line-height: 15px;
    height: 15px;
    font-size: 13px;
    text-align: center;
    color: rgb(186, 186, 186);
  }
  #g-p4_natanz-sm .g-pstyle4 {
    font-weight: 700;
    line-height: 16px;
    height: 16px;
    font-size: 16px;
    text-align: center;
    color: rgb(255, 255, 255);
  }
  #g-p4_natanz-sm .g-pstyle5 {
    height: 17px;
    color: rgb(255, 255, 255);
  }
  #g-p4_natanz-sm .g-pstyle6 {
    line-height: 13px;
    height: 13px;
    font-size: 14px;
    color: rgb(116, 116, 116);
  }
  #g-p4_natanz-sm .g-pstyle7 {
    font-weight: 700;
    height: 17px;
    color: rgb(165, 15, 21);
  }
  #g-p4_natanz-sm .g-cstyle0 {
    font-weight: 700;
    color: rgb(165, 15, 21);
  }
  #g-p4_natanz-md {
    position: relative;
    overflow: hidden;
  }
  #g-p4_natanz-md p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 400;
    line-height: 18px;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 16px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-p4_natanz-md .g-pstyle0 {
    line-height: 14px;
    height: 14px;
    font-size: 12px;
  }
  #g-p4_natanz-md .g-pstyle1 {
    line-height: 14px;
    height: 14px;
    letter-spacing: 0.2em;
    font-size: 12px;
    text-align: center;
    color: rgb(122, 122, 122);
  }
  #g-p4_natanz-md .g-pstyle2 {
    line-height: 15px;
    height: 15px;
    font-size: 15px;
    text-align: right;
    color: rgb(255, 255, 255);
  }
  #g-p4_natanz-md .g-pstyle3 {
    line-height: 15px;
    height: 15px;
    font-size: 13px;
    text-align: center;
    color: rgb(186, 186, 186);
  }
  #g-p4_natanz-md .g-pstyle4 {
    font-weight: 700;
    line-height: 19px;
    height: 19px;
    font-size: 17px;
    text-align: center;
    color: rgb(255, 255, 255);
  }
  #g-p4_natanz-md .g-pstyle5 {
    line-height: 17px;
    height: 17px;
    font-size: 15px;
    color: rgb(255, 255, 255);
  }
  #g-p4_natanz-md .g-pstyle6 {
    line-height: 17px;
    height: 17px;
    font-size: 15px;
    color: rgb(116, 116, 116);
  }
  #g-p4_natanz-md .g-pstyle7 {
    font-weight: 700;
    line-height: 17px;
    height: 17px;
    font-size: 15px;
    color: rgb(165, 15, 21);
  }
  #g-p4_natanz-md .g-cstyle0 {
    font-weight: 700;
    color: rgb(165, 15, 21);
  }
  #g-p4_natanz-lg {
    position: relative;
    overflow: hidden;
  }
  #g-p4_natanz-lg p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 400;
    line-height: 18px;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 16px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-p4_natanz-lg .g-pstyle0 {
    line-height: 14px;
    height: 14px;
    font-size: 12px;
  }
  #g-p4_natanz-lg .g-pstyle1 {
    line-height: 15px;
    height: 15px;
    font-size: 15px;
    text-align: right;
    color: rgb(255, 255, 255);
  }
  #g-p4_natanz-lg .g-pstyle2 {
    line-height: 14px;
    height: 14px;
    letter-spacing: 0.2em;
    font-size: 12px;
    text-align: center;
    color: rgb(122, 122, 122);
  }
  #g-p4_natanz-lg .g-pstyle3 {
    font-weight: 700;
    height: 18px;
    font-size: 19px;
    text-align: center;
    color: rgb(255, 255, 255);
  }
  #g-p4_natanz-lg .g-pstyle4 {
    line-height: 15px;
    height: 15px;
    font-size: 14px;
    text-align: center;
    color: rgb(163, 163, 163);
  }
  #g-p4_natanz-lg .g-pstyle5 {
    line-height: 14px;
    height: 14px;
    font-size: 15px;
    color: rgb(116, 116, 116);
  }
  #g-p4_natanz-lg .g-pstyle6 {
    line-height: 21px;
    height: 21px;
    font-size: 15px;
    color: rgb(255, 255, 255);
  }
  #g-p4_natanz-lg .g-pstyle7 {
    font-weight: 700;
    height: 18px;
    color: rgb(165, 15, 21);
  }
  #g-p4_natanz-lg .g-cstyle0 {
    font-weight: 700;
    color: rgb(165, 15, 21);
  }

  /* Custom CSS */
  .g-shadow {
    text-shadow:
      1px 1px 1px rgb(0 0 0 / 90%),
      1px -1px 1px rgb(0 0 0 / 90%),
      -1px 1px 1px rgb(0 0 0 / 90%),
      -1px -1px 1px rgb(0 0 0 / 90%);
  }
</style>
